// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  histId: __t.u64().primaryKey().name("hist_id"),
  identity: __t.identity(),
  other: __t.identity(),
  otherName: __t.string().name("other_name"),
  partyId: __t.u64().name("party_id"),
  at: __t.timestamp(),
});
